// React
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Components
import { Breakdown } from './styles'
import P from 'ui/elements/P'
import Hr from 'ui/elements/Hr'

// Shared
import { Format as FormatUtils } from 'back_office/v2/utils/utils'
import { withTranslation } from 'shared/utils/withTranslation'

const Discounts = ({ lines, currency }) => {
  if (!lines.length) return null

  return (
    <Fragment>
      <Breakdown>
        {lines.map(({ key, label, value }) => (
          <Fragment key={key}>
            <P>{label}</P>
            <P>{FormatUtils.money(value, currency)}</P>
          </Fragment>
        ))}
      </Breakdown>
      <Hr />
    </Fragment>
  )
}

Discounts.propTypes = {
  lines: PropTypes.array,
  currency: PropTypes.object
}

const mapStateToProps = (state, props) => {
  const lines = []

  const currency = state.client.currency.toJS()
  const coupon = state.orm.coupons.getById(props.cart.coupon_id)
  const discountLabel = props.t('user.checkout.discount')

  if (props.cart.discount_percentage !== 0) {
    lines.push({
      key: 'cart',
      label: props.t('user.auth.account_discount'),
      value: props.cart.discount_in_cents * -1
    })
  }

  if (coupon) {
    let label
    const value = props.cart.coupon_discount_in_cents * -1

    if (coupon.coupon_type === 'percentage') {
      label = `${props.t('user.checkout.coupon')}: ${coupon.value}% ${discountLabel.toLowerCase()}`
    } else {
      label = `${props.t('user.checkout.coupon')} ${discountLabel.toLowerCase()}`
    }

    lines.push({ key: 'coupon', label, value })
  }

  return {
    lines,
    currency
  }
}

export default compose(
  withTranslation('user'),
  reduxConnect(mapStateToProps)
)(Discounts)
